import React from "react"
import {graphql } from "gatsby"

import Header from '../components/Header/Header';
import SectionWrapper from '../components/SectionWrapper/SectionWrapper';
import SEO from "../components/seo";

const Prowadzacy = ({data}) => {

  const tomekPhoto = data.tomek.childImageSharp.fluid;
  const krzysztofPhoto = data.krzysztof.childImageSharp.fluid;
  const bartekPhoto = data.bartek.childImageSharp.fluid;
 
  const titleText = "Konferansjerzy i prowadzący";
  const paragraphText = "Poznaj naszych profesjonalnych konferansjerów na wesele. Doświadczony prowadzący zapewnie niezapomnianą uroczystość weselną."; 

  const content = [
    {
      title: "Konferansjer Tomek",
      text: "Ma dziesięc lat doświadczenia w prowadzeniu różnego rodzaju imprez i spotkań firmowych. Jako konferansjer weselny czuje się najlepiej. Jest pogodnym człowiekiem o zawsze dobrym humorze. Perfekcyjnie potrafi wyczuć nastrój gości weselnych. Jeśli szukają Państwo prowadzącego o wysokiej kulturze osobistej, Tomek jest osobą idealnądo wykonania takiego zadania.",
      image: tomekPhoto,
      alt: "Konferansjer Tomek",
      items: 3,
      link: "https://vimeo.com/296138907",
      target: "yes"
    },
    {
      title: "Prowadzący Krzysztof", 
      text: "Prawdziwy klimat budują światła. To one zapewniają prawdziwą dyskotekową, imprezową oprawę wizualną na każdej zabawie tanecznej. Posiadamy sprzęt oświetleniowy najwyżej klasy, który może działać zarówno automatycznie jak i z pełną obsługą profesjonalnego realizatora światła. W naszej ofercie zapewniamy również usługę tworzenia wizualizacji w technologii mappingu, niekonwencjonalne pokazy laserowe oraz możliwość odtworzenia filmów.",
      image: krzysztofPhoto,
      alt: "Prowadzący Krzysztof",
      items: 3,
      link: "https://vimeo.com/292279288",
      target: "yes"
    },
    {
      title: "Wodzirej Bartek", 
      text: "Niektóre wesela potrzebują pomocy profesjonalisty aby wszystko „ruszyło z kopyta”. Taką osobą jest nasz wodzirej Krzysztof. Bardzo utalentowany mówca, komik amator i standupper, który rozbawi każdego. Krzysztof to wszechstronny wodzirej, który doskonale poprowadzi konkurs, komicznie go skomentuje i zapewni niezapomniany wieczór dla Państwa młodych i ich gości.",
      image: bartekPhoto,
      alt: "Wodzirej Bartek",
      items: 3,
      link: "https://vimeo.com/310952591",
      target: "yes"
    },
  ];

  const bgimage = data.bgImage.childImageSharp.fluid;
  return (
    <>
      <SEO title="Prowadący wesele"/>
      <Header link={bgimage}/>
      <SectionWrapper content={content} title={titleText} text={paragraphText} fourItems={true} resize="yes"/>
    </>
  )
}

export const query = graphql`
  {
    tomek: file(name: {eq: "konferansjertomasz"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    krzysztof: file(name: {eq: "konferansjermariusz"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    bartek: file(name: {eq: "konferansjerbartek1"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    bgImage: file(name: {eq: "Konferansjerzy"}) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 1200) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`;

export default Prowadzacy